import { objectEntries } from '~/web-frontend-core/base/lib';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
/** Состояния видов спорта */
export class SportsStates extends Subscribtion {
    constructor() {
        super(...arguments);
        this.sports = {};
        this.sortedSportIds = [];
    }
    getData() {
        return {
            sports: this.sports,
            sortedSportIds: this.sortedSportIds,
        };
    }
    setData(sports, sortedSportIds) {
        this.sortedSportIds = sortedSportIds;
        this.sports = sports;
    }
    clear() {
        this.sports = {};
        this.sortedSportIds = [];
    }
    update(data) {
        objectEntries(data).forEach(([sportID, sport]) => {
            this.sports[sportID] = Object.assign(this.sports[sportID] || {}, sport);
        });
    }
    updateSortedIDs(sortedSportIds) {
        this.sortedSportIds = sortedSportIds;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/matchesList/Sports.js